/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type TradeRewardsMessagingWrapper_user = {
    readonly serviceId: string | null;
    readonly tradeFirm?: {
        readonly " $fragmentRefs": FragmentRefs<"RewardsMessageProvider_tradeFirm">;
    } | null;
    readonly " $refType": "TradeRewardsMessagingWrapper_user";
};
export type TradeRewardsMessagingWrapper_user$data = TradeRewardsMessagingWrapper_user;
export type TradeRewardsMessagingWrapper_user$key = {
    readonly " $data"?: TradeRewardsMessagingWrapper_user$data;
    readonly " $fragmentRefs": FragmentRefs<"TradeRewardsMessagingWrapper_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "TradeRewardsMessagingWrapper_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "tradeFirm",
          "storageKey": null,
          "args": null,
          "concreteType": "TradeFirmType",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "RewardsMessageProvider_tradeFirm",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'c29a706e72758728c590a8b824aa5308';
export default node;
